import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0102 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="高年齢者雇用安定法改正について。企業の実務対応策とは？" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2026.04.17</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        少子高齢化社会が到来し、高年齢労働者の労働参加は、事業の継続にとっては必要不可欠な要素となっています。特に高年齢労働者はこれまで培ってきた技能や経験値を多く兼ね備えているため、体力の低下は否めないものの、企業にとって重要な戦力となりえます。今回はそのような高年齢労働者に関する労働関係法令の1つであり、かつ、近年法改正もあった高年齢者雇用安定法について解説します。
      </p>
      <img src="/images/column/details/c0102.jpg" alt="キンクラコラム画像102" />
      <div id="toc1">
        <h1>高年齢者雇用安定法の改正点の経緯とその実務対応</h1>
      </div>
      <p>
        雇用安定法は、
        <span>直近では2021年の4月に大きな改正が行われました</span>
        。法改正の枢要部としては、65歳以降の就業確保措置です。現行の法律では、
        <span>
          定年の下限年齢は一部の業種を除き、60歳と定められており、60歳から65歳までは、労働者の求めがあれば、継続雇用制度等を用いて就業の確保が義務付けられています
        </span>
        。もちろん、定年年齢の延長（例えば、定年を60歳から65歳まで引き上げ）で65歳までの雇用を確保をすることも問題はありませんが、定年年齢を延長すると言う事は、当該定年年齢までは正社員等としての身分を保障することとなるため、経営上の問題をはらんでいることから、実務上は継続雇用制度が多く用いられているのが現状です。
      </p>

      <div id="toc2">
        <h1>継続雇用制度の見直し</h1>
      </div>
      <p>
        継続雇用制度については、形式的に1年ごとに契約更新とすることは特段差し支えありません。ただし、労働者の意に反して、
        <span>
          あまりにも多くの更新条件（更新を求めてきた場合であっても高いハードルを課す）設ける事は、法令遵守している状態とは言えませんので、そのような就業規則の条文が明記されている場合は、速やかな見直しが必要
        </span>
        です。
      </p>

      <div id="toc3">
        <h1> 企業の努力義務の強化</h1>
      </div>
      <p>
        2021年4月以降は努力義務ではあるものの、
        <span>65歳から70歳までの高年齢者就業確保措置が法律上記されており</span>
        、具体的には次の項目のいずれかが明記されています。
        <br />
        <br />
        ・ 70歳までの定年年齢の引き上げ
        <br />
        ・定年の廃止
        <br />
        ・ 70歳までの継続雇用制度（再雇用制度等）の導入
        <br />
        これは、他の事業主も含むと解されます。また、雇用契約に限定されず、70歳まで継続的に
        <span>業務委託契約を締結する制度も含まれます</span>
        。実務上は、雇用契約と業務委託は全く異なる制度であり、具体的には、業務委託契約の場合には、これまで対象となっていた社会保険制度も対象外となるため、選択肢を提示するにあたっては変更部分について、十分な説明が求められます。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc4">
        <h1>
          高年齢者雇用安定法に対応するための実務対応
          <br />
          雇用契約の見直しについて
        </h1>
      </div>
      <p>
        人手不足への対応、並びに高年齢者雇用安定法を遵守していく事は当然重要なことではありますが、
        <span>
          雇用契約を締結すると言う事は、同時に企業としては、安全配慮義務の履行も求められます
        </span>
        。労働者目線としてもより
        <span>
          長期的な雇用契約を締結してもらう事は粋に感じる事は想像に難くありません
        </span>
        。ただし、労働者によっては責任感の強さから無理な労働が祟り、健康被害や労災事故につながってしまうという事例も散見されます。よって、ある程度フレキシブルな働き方を選択肢として入れることによって、高年齢労働者としても、体調に配慮しながら、無理せず、仕事と家庭生活の両立ができるものと考えられます。特に、定年到達前まで一定以上の職責についていた労働者の場合、責任感の強さから、無理をしてしまう傾向が少なくありません。
        <br />
        <br />
        これらの新たな働き方を導入するには、
        <span>就業規則の改定が不可避</span>
        です。高年齢労働者を対象とした新たな制度導入については、独立行政法人高齢・障害・求職者雇用支援機構が周知する助成金制度の活用を検討するのも有用です。
      </p>

      <div id="toc5">
        <h1>企業の取り組み事例</h1>
      </div>
      <p>
        <span>
          定年退職後、再雇用制度等によって労働に従事する高年齢労働者に対しても、専門職制度（年齢労働者に特化した役職など等）を導入している事例
        </span>
        があります。繰り返しになりますが、高年齢労働者は、年齢の上昇に伴い、体力の低下は否めないものの、
        <span>
          一定の技能や経験値を持っていることから、企業にとっても余人に代えがたい人材であることが否めません
        </span>
        。そのような人材が在籍しているうちに、比較的若手の従業員に対して技能の伝承や、積極的な指導を行ってもらえるような役職を設け、計画的に知識・技能の継承を行う取り組みを企業があります。特に、
        <span>
          職人的な要素が含む業種（例えば製造業）については、年齢に裏打ちされた知識、技能は、長きにわたって継承されていくことによって、企業の価値にもつながる
        </span>
        ことから、このような取り組みが行われています。
      </p>

      <div id="toc6">
        <h1>最後に</h1>
      </div>
      <p>
        人口割合から勘案しても、高年齢労働者は今後も増加傾向にある事は否めません。そのような状況であれば、退いてもらうことを念頭に考えるよりも、より活躍の場を広めて企業としてもよりレベルアップできるような人事戦略を立てていくことの方が労使双方にとってもメリットが多いと考えます。特に出生率の低下を勘案しても今後更なる法改正がないとも言えず、先進的な取り組みを継続しておくことで、法改正（例えば定年年齢の延長）に対応するための労力も軽減することが可能と考えます。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0102
